import { useEffect, useState } from 'react';
import { useCurrentUserStore } from 'store/UserStore';
import { Permission } from 'interfaces';
import { useIsAdmin } from 'hooks/useIsAdmin';
import { useIsTokenExpired } from './useIsTokenExpired';
import { useNotification } from '@refinedev/core';

interface CanAccessReturn {
  isExpired: boolean;
  isAdmin: boolean;
  canAccess: boolean;
}

export const useCanAccess = (path: string): CanAccessReturn => {
  const { role } = useCurrentUserStore();
  const isAdmin = useIsAdmin();
  const isExpired = useIsTokenExpired();
  const { open } = useNotification();
  const [canAccess, setCanAccess] = useState<boolean>(true);

  useEffect(() => {
    if (isExpired) {
      open?.({
        message: 'Your session has expired. The page will refresh.',
        type: 'error',
      });
      setCanAccess(false);
      // wait 4 seconds before refreshing
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    } else if (isAdmin) {
      setCanAccess(true);
    } else {
      const permissions = role?.permissions ?? [];
      const nextValue = permissions.some(
        (permission: Permission) => permission.resource === path
      );
      setCanAccess(role != null && nextValue);
    }
  }, [isExpired, isAdmin, path, role]);

  return { isExpired, isAdmin, canAccess };
};
